import LinearScaleModel from "./LinearScaleModel.js";
import BandScaleModel from "./BandScaleModel.js";
import TimeScaleModel from "./TimeScaleModel.js";
import UTCScaleModel from "./UTCScaleModel.js";
import * as Util from "./Util.js";
export { LinearScaleModel, BandScaleModel, TimeScaleModel, UTCScaleModel, Util as ScaleUtil };
export const ALL_SCALE_MODELS = [LinearScaleModel, BandScaleModel, TimeScaleModel, UTCScaleModel];
export default {
  createScaleModel(unitType) {
    switch (unitType) {
      case 'timestamp':
        return TimeScaleModel.create();
      default:
        return LinearScaleModel.create();
    }
  }
};